import { Box, ColorOptions, Text, useWindowDimensions } from '@jfs/ui-new'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth } from '../../util/util'
import { styles } from './styles'

export const AdvantageSection = ({ data }: any) => {
  const viewPortWidth = useWindowDimensions()
  const resPadding = usePadding()
  const { textSize, textLineHeight } = useFontSize()
  const themedStyle = styles(viewPortWidth, resPadding)
  const isMobile = isMobileWidth(viewPortWidth)
  const isTab = isTabletWidth(viewPortWidth)

  const padding = resPadding >= 350 ? 120 : resPadding
  return (
    <Box marginTop={-100}>
      <Box flexDirection={isMobile ? 'column' : 'row'} height={isTab ? 300 : isMobile ? 585 : 440}>
        <Box
          {...themedStyle.bgRadius}
          borderTopRightRadius={isMobile ? 32 : 0}
          bg={'WHITE' as ColorOptions}
          f={0.5}
          justify={isTab ? undefined : 'center'}
          pt={isTab ? 80 : 0}
          align={'flex-start'}
          height={'100%'}>
          <Box
            bg={'#24397A0A' as ColorOptions}
            justify={isTab ? undefined : 'center'}
            pv={isTab ? 80 : 120}
            pl={resPadding}
            pr={isMobile ? padding : 120}
            align={'flex-start'}
            w={'100%'}
            height={'100%'}>
            <Box h={32} w={128} borderRadius={16} bg={'#24397A' as ColorOptions} justify={'center'} align={'center'}>
              <Text
                title={'ADVANTAGE'}
                color={'WHITE'}
                fontSize={isMobile || isTab ? 12 : 14}
                letterSpacing={1.4}
                fontFamily={'jiotype-bold'}
              />
            </Box>
            <Box minHeight={isTab ? 100 : undefined} pt={isMobile || isTab ? 25 : 40} width={'100%'}>
              <Text
                title={data.advantage}
                color={'#24397A' as ColorOptions}
                fontSize={textSize}
                fontFamily={'jiotype-medium'}
                lineHeight={textLineHeight}
              />
            </Box>
          </Box>
        </Box>
        <Box
          {...themedStyle.bgRadius}
          borderTopRightRadius={isMobile ? 0 : isTab ? 32 : 100}
          borderTopLeftRadius={0}
          backgroundColor={'WHITE' as ColorOptions}
          f={0.5}
          height={'100%'}
          justify={isTab ? undefined : 'center'}
          pt={isTab ? 80 : 0}
          align={'flex-start'}>
          <Box
            bg={'#24397A14' as ColorOptions}
            justify={isTab ? undefined : 'center'}
            pv={isTab ? 80 : 120}
            pl={isMobile ? padding : 120}
            pr={resPadding}
            align={'flex-start'}
            w={'100%'}
            height={'100%'}>
            <Box h={32} w={118} borderRadius={16} bg={'#24397A' as ColorOptions} justify={'center'} align={'center'}>
              <Text
                title={'IDEAL FOR'}
                color={'WHITE'}
                fontSize={isMobile || isTab ? 12 : 14}
                letterSpacing={1.4}
                fontFamily={'jiotype-bold'}
              />
            </Box>
            <Box minHeight={isTab ? 100 : undefined} pt={isMobile || isTab ? 25 : 40} width={'100%'}>
              <Text
                title={data.idealFor}
                color={'#24397A' as ColorOptions}
                fontSize={textSize}
                fontFamily={'jiotype-medium'}
                lineHeight={textLineHeight}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
